import { render, staticRenderFns } from "./TicketWorkspace.vue?vue&type=template&id=8963cbe4&"
import script from "./TicketWorkspace.vue?vue&type=script&lang=js&"
export * from "./TicketWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports